import { Block, Inline } from '@contentful/rich-text-types';
import Context from '@/services/contentful/pageContext';
import Link from '@/services/contentful/contentTypes/Link';
import Media from '@/services/contentful/contentTypes/Media';
import LinkCRC from '@/components/contentful/Link/Link';
import MediaCRC from '@/components/contentful/Media';

interface Props {
    node: Block | Inline;
}

type ValidEmbedTypes = 'Link' | 'Media';

export default function InlineEmbed({ node }: Props) {
    const asset = node.data.target;
    const type: ValidEmbedTypes = asset.sys.contentType?.sys.id;

    let parsed: SiteAsset = {
        cms_id: '',
        cms_type: '',
        fields: {},
    };

    if (type === 'Link') {
        parsed = Link(asset, {} as Context);
        return <LinkCRC asset={parsed as SiteLink} />;
    } else if (type === 'Media') {
        parsed = Media(asset);
        return <MediaCRC asset={parsed as SiteMedia} />;
    }

    return <></>;
}
